<template>
  <div class="hvh-flex grow-1">
    <FixedPlaceholder :component="CallPlanningLeftMenu" />
    <div class="hvh-flex grow-1 overflow-hidden">
      <slot name="menu" />
      <div class="hvh-flex column grow-1 overflow-hidden">
        <div class="p-5 h-100">
          <div class="mb-3" v-if="brandId">
            <h2 v-if="role">{{ role }}</h2>
            <h2>Brand: {{ brand?.name || '-' }}</h2>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios';
import FixedPlaceholder from '../common/fixedPlaceholder/FixedPlaceholder.vue';
import CallPlanningLeftMenu from './CallPlanningLeftMenu.vue';
export default {
  components: { FixedPlaceholder, },
  props: ['userId', 'prop'],
  data() {
    return {
      brand: null,
      CallPlanningLeftMenu
    };
  },
  computed: {
    brandId() {
      return this.$route.params.brandId;
    },
    role() {
      if (!this.prop || !this.brand) return '';
      var { regions, territories } = this.brand[this.prop];
      return `${this.prop.capitalize()} (${[...regions, ...territories].join(', ')})`;
    },
  },
  mounted() {
    if (this.brandId) {
      axios.get(`/api/CallPlanning/Brands/${this.brandId}`, { params: { userEmail: this.userId } })
        .then(({ data }) => this.brand = data);
    }
  }
}
</script>
